import { render } from "./ServicesSectionComponent.vue?vue&type=template&id=79663db8&scoped=true"
import script from "./ServicesSectionComponent.vue?vue&type=script&lang=js"
export * from "./ServicesSectionComponent.vue?vue&type=script&lang=js"

import "./ServicesSectionComponent.vue?vue&type=style&index=0&id=79663db8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79663db8"]])

export default __exports__